<template>
  <sf-dialog v-model="dialog">
    <template #activator="{ props }">
      <sf-text-button size="small" v-bind="props">
        {{ $t('forgotPassword') }}
      </sf-text-button>
    </template>
    <v-card>
      <v-card-item>
        <v-card-title>
          <sf-heading>{{ $t('forgotPassword') }}</sf-heading>
        </v-card-title>
      </v-card-item>
      <v-card-text class="pb-0">
        <v-form ref="form" v-model="valid" lazy-validation>
          <sf-text-field
            v-model="mail"
            :label="$t('emailAddress') + ' *'"
            :rules="[rules.requiredRule, rules.mailRule]"
            required
            @keydown.enter.prevent="reset"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <sf-text-button color="grey" class="text-medium-emphasis" @click="close">
          {{ $t('cancel') }}
        </sf-text-button>
        <sf-text-button color="primary" :disabled="!valid" @click="reset">
          {{ $t('send') }}
        </sf-text-button>
      </v-card-actions>
    </v-card>
  </sf-dialog>
</template>

<script setup lang="ts">
import SfTextButton from '@/components/button/SfTextButton.vue'
import SfDialog from '@/components/dialog/SfDialog.vue'
import SfTextField from '@/components/input/SfTextField.vue'
import SfHeading from '@/components/text/SfHeading.vue'
import rules from '@/rules'
import { ref, useTemplateRef, watch } from 'vue'
import type { VForm } from 'vuetify/components'

const componentProps = defineProps({
  email: {
    type: String,
    default: ''
  }
})

const emit = defineEmits<{
  (e: 'reset', mail: string): void
}>()

const form = useTemplateRef<VForm>('form')
const dialog = ref(false)
const mail = ref('')
const valid = ref(false)

const close = () => {
  dialog.value = false
}

const reset = async () => {
  dialog.value = false
  emit('reset', mail.value)
}

watch(dialog, (newValue) => {
  if (newValue) {
    mail.value = componentProps.email
    form.value?.resetValidation()
  }
})
</script>
